import { MenuItem } from '../interface/navigation.interface';
import { UserRole } from '@const/users.enum';

/**
 * Helper function to check if a user has access to a menu item
 * @param userRoles Array of user roles
 * @param allowedRoles Array of roles allowed for the menu item
 * @returns boolean indicating if user has access
 */
export function hasMenuAccess(userRoles: UserRole[], allowedRoles: UserRole[]): boolean {
  // Admin role has access to everything
  if (userRoles.includes('admin' as unknown as UserRole)) {
    return true;
  }

  // Check if user has any of the allowed roles
  return userRoles.some((role) => allowedRoles.includes(role));
}

/**
 * Filter menu items based on user roles
 * @param menuItems Array of menu items to filter
 * @param userRoles Array of user roles
 * @returns Filtered array of menu items the user has access to
 */
export function filterMenuByRoles(menuItems: MenuItem[], userRoles: UserRole[]): MenuItem[] {
  return menuItems
    .filter((item) => hasMenuAccess(userRoles, item.allowedRoles))
    .map((item) => ({
      ...item,
      submenu: item.submenu?.filter((subItem) => hasMenuAccess(userRoles, subItem.allowedRoles)),
    }));
}

/**
 * Ensures only one menu item can be expanded at a time
 * @param menuItems Array of menu items
 * @param targetItem The item to expand (all others will be collapsed)
 */
export function toggleSingleMenuExpansion(menuItems: MenuItem[], targetItem: MenuItem): void {
  menuItems.forEach((item) => {
    if (item !== targetItem) {
      item.expanded = false;
    }
  });
  targetItem.expanded = !targetItem.expanded;
}
